module.exports = __webpack_public_path__ + "img/business-img-2.9ece9679.png";